import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  caption: {
    fontSize: 12,
    lineHeight: '17px',
    color: 'var(--color-gray-3)',
    textAlign: 'left',
    '& span': {
      color: 'var(--color-sub)'
    }
  },
  linkContainer: {
    margin: '24px 24px 0'
  },
  link: {
    textDecoration: 'none',
    color: 'var(--color-key)',
    fontWeight: 600
  }
}));

const PdfLink: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.linkContainer}>
        <p className={classes.caption}>
          別途、郵送されるパンフレットでご説明している電気プラン、サービスは
          <a
            className={classes.link}
            href="https://home.osakagas.co.jp/electricity/lp/sumamoru/pdf/sumamoru.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            こちら
          </a>
          からご確認いただけます。
        </p>
      </div>
    </>
  );
};

export default PdfLink;
